export enum EnumTelefoneTipo {
    RESIDENCIAL = 1,
    COMERCIAL = 2,
    CELULAR = 3
}

export type TypeTelefoneTipo = {
    codigo?: number,
    tipo?: string
}

export type TypeTelefone = {
    codigo?: number,
    tipo?: TypeTelefoneTipo,
    nomeContato?: string,
    ddd?: string,
    numero?: string,
    ramal?: string,
    principal?: boolean,
    ativo?: boolean,
    ocupacao?: string
}